import request from '@/router/axios'

export function getSourceList(query) {
  return request({
    url: '/news/sources',
    method: 'get',
    params: query
  })
}

export function getSourceListPage(query) {
  return request({
    url: '/news/sources/page',
    method: 'get',
    params: query
  })
}

export function getSource(id) {
  return request({
    url: '/news/sources/'  + id,
    method: 'get'
  })
}

export function updateSource(obj) {
  return request({
    url: '/news/sources',
    method: 'put',
    data: obj
  })
}